import React from 'react';

// Renders the before/after summary of a graph change (see
// strategies/builder_chat.py:diff_graphs) inline in a chat message.
export default function GraphDiffCard({ diff }) {
  if (!diff || !diff.summary_lines || diff.summary_lines.length === 0) return null;
  return (
    <div style={{
      marginTop: 6,
      padding: '10px 12px',
      borderRadius: 8,
      background: 'var(--surface)',
      border: '1px solid var(--border)',
      fontSize: 12,
    }}>
      <div style={{
        fontWeight: 700, marginBottom: 6, color: 'var(--muted)',
        textTransform: 'uppercase', letterSpacing: 0.4, fontSize: 10,
      }}>
        What changed
      </div>
      <ul style={{ margin: 0, padding: '0 0 0 16px', lineHeight: 1.6 }}>
        {diff.summary_lines.map((line, i) => (
          <li
            key={i}
            style={{
              color: line.startsWith('+') ? 'var(--teal)' : line.startsWith('-') ? 'var(--red)' : 'var(--text)',
            }}
          >
            {line}
          </li>
        ))}
      </ul>
    </div>
  );
}
